import { functions } from 'helpers';
import { constants } from 'helpers/constants';
import moment from 'moment';

import type ICoProducer from 'interfaces/ICoProducer';
import type IProduct from 'interfaces/IProduct';

class Product implements IProduct {
  active: number = this.product.active === null || this.product.active === undefined ? 1 : this.product.active;
  affiliate_instructions: string = this.product.affiliate_instructions || '';
  affiliation_contract: string = this.product.affiliation_contract || '';
  affiliation_status: string = this.product.affiliation_status || '';
  allow_affiliation: boolean = this.product.allow_affiliation || false;
  allows_boleto: boolean = this.product.allows_boleto || false;
  allows_card: boolean = this.product.allows_card || false;
  allows_downgrade: boolean = this.product.allows_downgrade || false;
  allows_eduzz_balance: boolean = this.product.allows_eduzz_balance || false;
  allows_multiple_cards: boolean = this.product.allows_multiple_cards || false;
  allows_paypal: boolean = this.product.allows_paypal || false;
  allows_pix: boolean = this.product.allows_pix || false;
  allows_upgrade: boolean = this.product.allows_upgrade || false;
  alternative_url: string = this.product.alternative_url || '';
  ask_address_checkout: boolean = this.product.ask_address_checkout || false;
  ask_address_thanks: boolean = this.product.ask_address_thanks || false;
  author_name: string = this.product.author_name || '';
  auto_affiliation: boolean = this.product.auto_affiliation || false;
  auto_refund: boolean = this.product.auto_refund || false;
  can_create_pixel: boolean = this.product.can_create_pixel || false;
  categories: any[] = this.product.categories || [];
  charge_type: string = this.product.charge_type || 'N';
  cnt_partner_cod: number = this.product.cnt_partner_cod || null;
  comission_type: string = this.product.comission_type || 'P';
  comission_value: number = this.product.comission_value || 0;
  connects: number = this.product.connects || 0;
  coproducers: Array<ICoProducer> = this.product.coproducers || [];
  currency_id: number = this.product.currency_id || 1;
  price: number = this.product.price || 0;
  recurring_value: number = this.product.recurring_value || 0;
  recurring_frequency_type: string = this.product.recurring_frequency_type || 'M';
  recurring_frequency_type_select: string = this.product.recurring_frequency_type_select;
  recurring_frequency: number = this.product.recurring_frequency ?? 1;
  undetermined_charges: boolean = this.product.undetermined_charges || false;
  limit_charges: number = this.product.limit_charges ?? 2;
  overdue_limit: number = this.product.overdue_limit ?? 5;
  permanent_access: boolean = this.product.permanent_access || false;
  default_sales_page: string = this.product.default_sales_page || '';
  deliver_first_charge: boolean = this.product.deliver_first_charge || false;
  deliveries: Array<any> = this.product.deliveries || [];
  description: string = this.product.description || '';
  document_on_checkout: boolean = this.product.document_on_checkout || false;
  email_welcome: boolean = this.product.email_welcome || false;
  expiration_date: string = this.product.expiration_date || null;
  friendly_name: string = this.product.friendly_name || '';
  funnel_commission: number = this.product.funnel_commission || (this.product.infinity_funnel ? 50 : 0);
  has_children: boolean = this.product.has_children || false;
  has_expiration_date: boolean = this.product.has_expiration_date || false;
  hide_quantity: boolean = this.product.hide_quantity || false;
  id: number = this.product.id || 0;
  image_id: number = this.product.image_id || null;
  image: string = this.product.image || null;
  infinity_funnel: boolean = this.product.infinity_funnel || false;
  interest_free_installment: boolean = this.product.interest_free_installment || false;
  is_producer: boolean = this.product.is_producer || false;
  launch_date: string = this.product.launch_date || '';
  marketplace_variation: number = this.product.marketplace_variation || null;
  marketplace: boolean = this.product.marketplace || false;
  membership_comission_type: string = this.product.membership_comission_type || 'P';
  membership_comission_value: number = this.product.membership_comission_value || 0;
  membership_fee: boolean = this.product.membership_fee || false;
  membership_price: number = this.product.membership_price || 0;
  moderation_status: string = this.product.moderation_status || '';
  name_extract_description: string = this.product.name_extract_description || '';
  notify_stock: number = this.product.notify_stock || 0;

  parent_id: number = this.product.parent_product || null;
  parent_product: number = this.product.parent_product || null;

  physicalDelivery: any = this.product.physicalDelivery || null;
  prelaunch: boolean = this.product.prelaunch || false;

  private_label_rights: number = this.product.private_label_rights || 0;
  producer_id: number = this.product.producer_id || 0;
  program_content: string = this.product.program_content || '';
  recovery_email: string = this.product.recovery_email || '';
  recruit_commission_type: string = this.product.recruit_commission_type || 'P';
  recruit_commission_value: number = this.product.recruit_commission_value || 0;
  recruit_max_sales: number = this.product.recruit_max_sales || 0;
  recruit: boolean = this.product.recruit || false;
  recurring_comission_type: string = this.product.recurring_comission_type || 'P';
  recurring_comission_value: number = this.product.recurring_comission_value || 0;
  recurring_days_start_charging: number = this.product.recurring_days_start_charging || null;
  recurring_start_charging: string = this.product.recurring_start_charging || '';
  comission_on_first_invoice: boolean = this.product.comission_on_first_invoice || false;

  refund_days: number = this.product.refund_days || 7;
  remove_access: boolean = this.product.remove_access || false;
  sales_expectation: number = this.product.sales_expectation || 0;
  sales_recovery: boolean = this.product.sales_recovery || false;
  stock: number = this.product.stock || 0;
  sku: string = this.product.sku || '';
  support_email: string = this.product.support_email || '';
  thankyou_type: number = this.product.thankyou_type || 99;
  title: string = this.product.title || '';
  trial_days: number = this.product.trial_days || 1;
  trial: boolean = this.product.trial || false;
  type: number = this.product.type || 1;

  unlimited_installment: boolean = this.product.unlimited_installment || false;
  url_checkout: string = this.product.url_checkout || '';
  url_thankyou_boleto: string = this.product.url_thankyou_boleto || '';
  url_thankyou_card: string = this.product.url_thankyou_card || '';
  visible: boolean = this.product.visible || false;
  webhook_type: string = this.product.webhook_type || 'E';
  webhook_url: string = this.product.webhook_url || '';
  webhook: boolean = false;

  yearly_installment: boolean =
    this.product.yearly_installment && this.product.recurring_frequency_type !== 'M' && this.product.recurring_frequency_type_select !== 'MONTH';

  send_billing_reminder: boolean = this.product.send_billing_reminder || false;

  private nullableFields: string[] = [
    'url_thankyou_card',
    'url_thankyou_boleto',
    'alternative_url',
    'friendly_name',
    'affiliate_instructions',
    'affiliation_contract',
  ];

  constructor(private product: Partial<IProduct> = {}) {}

  setCategories(categories: any): void {
    this.categories = categories;
  }

  getIdCategories(): Array<number> {
    return this.categories && Array.isArray(this.categories)
      ? (this.categories.map((item: any) => (item && item.id ? item.id : item)) as Array<number>)
      : [];
  }

  getRecurringStartCharging(): string {
    return this.recurring_start_charging ? moment(this.recurring_start_charging).format('YYYY-MM-DD') : null;
  }

  getExpirationDate(): string {
    return this.expiration_date ? moment(this.expiration_date).format('YYYY-MM-DD') : '';
  }

  getLaunchDate(): string {
    return this.launch_date ? moment(this.launch_date).format('YYYY-MM-DD') : '';
  }

  hasVariations(): boolean {
    return this.has_children;
  }

  isMainProduct(): boolean {
    return !this.parent_product;
  }

  isVariation(): boolean {
    return this.parent_product && this.parent_id !== 0;
  }

  isMainWithChildren(): boolean {
    return !this.parent_product && this.has_children;
  }

  setParent(id: number): void {
    this.parent_product = id;
    this.parent_id = id;
  }

  getCoProducers(): Array<ICoProducer> {
    return this.coproducers;
  }

  setCoProducers(cps: Array<ICoProducer>): void {
    this.coproducers = cps || [];
  }

  addNewCoProducer(cp: ICoProducer): void {
    this.coproducers.push(cp);
  }

  removeCoProducer(cp: ICoProducer): void {
    this.coproducers = this.coproducers.filter((item: ICoProducer) => item !== cp);
  }

  getNewCoProducers(): Array<ICoProducer> {
    return this.coproducers.filter((item: ICoProducer) => item.new);
  }

  getCoProducersForSubmit(): Array<ICoProducer> {
    return this.coproducers.filter((item: ICoProducer) => item.new || item.active);
  }

  getDeliveries(): Array<any> {
    return this.deliveries;
  }

  setDeliveries(dvs: Array<any>): void {
    this.deliveries = dvs || [];
  }

  addNewDelivery(dv: any): void {
    this.deliveries.push(dv);
  }

  removeDelivery(dv: any): void {
    this.deliveries = this.deliveries.filter((item: any) => item !== dv);
  }

  getPhysicalDelivery(): any {
    if (this.type === constants.PHYSICAL) {
      return this.product.physicalDelivery;
    }
    return null;
  }

  setPhysicalDelivery(pd: any): void {
    if (this.type === constants.PHYSICAL) {
      this.physicalDelivery = pd;
    }
  }

  getGeneralProperties(): any {
    return {
      title: `${this.title} -  Variação ${moment().format('DD/MM HH:mm')}`,
      description: this.description,
      image_id: this.image_id,
      image: this.image,
      expiration_date: this.expiration_date,
      has_expiration_date: this.has_expiration_date,
      type: this.type,
      author_name: this.author_name,
      alternative_url: this.alternative_url,
      refund_days: this.refund_days,
      prelaunch: this.prelaunch,
      launch_date: this.launch_date,
      sales_expectation: this.sales_expectation,
      program_content: this.program_content,
      support_email: this.support_email,
      categories: this.categories,
      friendly_name: this.friendly_name,
      auto_refund: this.auto_refund,
      marketplace: this.marketplace,
      marketplace_variation: this.marketplace_variation,
    };
  }

  getSalesProperties(): any {
    return {
      charge_type: this.charge_type,
      interest_free_installment: this.interest_free_installment,
      sales_recovery: this.sales_recovery,
      allows_boleto: this.allows_boleto,
      allows_pix: this.allows_pix,
      allows_paypal: this.allows_paypal,
      allows_multiple_cards: this.allows_multiple_cards,
      deliver_first_charge: this.deliver_first_charge,
      price: this.price,
      currency_id: this.currency_id,
      recurring_value: this.recurring_value,
      recurring_frequency_type: this.recurring_frequency_type,
      recurring_frequency: this.recurring_frequency,
      undetermined_charges: this.undetermined_charges,
      limit_charges: this.limit_charges,
      overdue_limit: this.overdue_limit,
      permanent_access: this.permanent_access,
      membership_fee: this.membership_fee,
      membership_price: this.membership_price,
      trial: this.trial,
      trial_days: this.trial_days,
      url_thankyou_boleto: this.url_thankyou_boleto,
      url_thankyou_card: this.url_thankyou_card,
      name_extract_description: this.name_extract_description,
      recovery_email: this.recovery_email,
      unlimited_installment: this.unlimited_installment,
      remove_access: this.remove_access,
      allows_card: this.allows_card,
    };
  }
  getAffiliatesProperties(): any {
    return {
      allow_affiliation: this.allow_affiliation,
      comission_type: this.comission_type,
      comission_value: this.comission_value,
      recurring_comission_type: this.recurring_comission_type,
      recurring_comission_value: this.recurring_comission_value,
      comission_on_first_invoice: this.comission_on_first_invoice,
      visible: this.visible,
      auto_affiliation: this.auto_affiliation,
      infinity_funnel: this.infinity_funnel,
      funnel_commission: this.funnel_commission,
      recruit: this.recruit,
      recruit_commission_type: this.recruit_commission_type,
      recruit_commission_value: this.recruit_commission_value,
      recruit_max_sales: this.recruit_max_sales,
      affiliate_instructions: this.affiliate_instructions,
      affiliation_contract: this.affiliation_contract,
      membership_comission_type: this.membership_comission_type,
      membership_comission_value: this.membership_comission_value,
    };
  }
  serviceFormat(): any {
    let image,
      currency_id,
      recurring_value,
      membership_price,
      price,
      comission_value,
      recruit_commission_value,
      categories,
      recurring_comission_value,
      membership_comission_value,
      expiration_date,
      launch_date;
    if (this.image_id) {
      image = String(this.image_id);
    }
    currency_id = 1;
    recurring_value = functions.clearMoneyMask(this.recurring_value);
    membership_price = functions.clearMoneyMask(this.membership_price);
    price = functions.clearMoneyMask(this.price);
    comission_value = functions.clearMoneyMask(this.comission_value);
    recruit_commission_value = functions.clearMoneyMask(this.recruit_commission_value);
    categories = this.getIdCategories();
    recurring_comission_value = functions.clearMoneyMask(this.recurring_comission_value);
    membership_comission_value = functions.clearMoneyMask(this.membership_comission_value);
    expiration_date = this.has_expiration_date ? moment(this.expiration_date).format('MM/DD/YYYY') : null;
    launch_date = this.prelaunch ? moment(this.launch_date).format('MM/DD/YYYY') : null;
    let newFormatProduct: any = {
      ...(this as any),
      image,
      currency_id,
      recurring_value,
      membership_price,
      price,
      comission_value,
      recruit_commission_value,
      categories,
      recurring_comission_value,
      membership_comission_value,
      expiration_date,
      launch_date,
    };

    const CUSTOM_RECURRING = 'P';
    if (this.recurring_frequency_type === CUSTOM_RECURRING) {
      if (this.recurring_frequency_type_select === 'MONTH') {
        newFormatProduct.recurring_frequency_type = 'M';
      }

      if (this.recurring_frequency_type_select === 'YEAR') {
        newFormatProduct.recurring_frequency_type = 'Y';
      }
    }

    //retirando espaço multiplos da descriçao
    //newFormatProduct.description = newFormatProduct.description.replace(/\s\s+/g, ' ');
    //se é produto físico
    if (this.type == 3) {
      newFormatProduct['type_freight'] = this.physicalDelivery.delivery_type;

      if (this.physicalDelivery.delivery_type == 3 || this.physicalDelivery.delivery_type == 4) {
        newFormatProduct['packing'] = this.physicalDelivery.format;
        //tipo de envios: SEDEX, SEDEX10 E PAC
        //40010,40215,41106

        newFormatProduct['type_delivery'] = this.physicalDelivery.delivery_options;

        newFormatProduct['cep_origin'] = this.physicalDelivery.zip_code;

        newFormatProduct['peso'] = functions.clearMoneyMask(this.physicalDelivery.weight);

        newFormatProduct['comprimento'] = this.physicalDelivery.length;

        if (this.physicalDelivery.format == 1 || this.physicalDelivery.delivery_type == 4) {
          newFormatProduct['largura'] = this.physicalDelivery.width;
          newFormatProduct['altura'] = this.physicalDelivery.height;
        }

        if (this.physicalDelivery.format == 2) {
          newFormatProduct['diametro'] = this.physicalDelivery.diameter;
        }
      }
      if (this.physicalDelivery.delivery_type == 2) {
        newFormatProduct['freight_value'] = functions.clearMoneyMask(this.physicalDelivery.delivery_value);
        newFormatProduct['deadline_delivery'] = this.physicalDelivery.delivery_days;
      }
      if (this.physicalDelivery.delivery_type == 1) {
        newFormatProduct['deadline_delivery'] = this.physicalDelivery.delivery_days;
      }
    }
    for (let key in newFormatProduct) {
      if (newFormatProduct[key] === '' || newFormatProduct[key] === null) {
        if (newFormatProduct[key] === '' && this.nullableFields.includes(key)) {
          continue;
        }

        delete newFormatProduct[key];
      }
    }
    if (newFormatProduct.id === 0) {
      delete newFormatProduct.id;
    }
    //TODO Verificar porque esta duplicando o object product
    delete newFormatProduct.product;
    // Se for vitrine nao mandar essas info
    if (this.isMainWithChildren()) {
      delete newFormatProduct.url_thankyou_card;
      delete newFormatProduct.url_thankyou_boleto;
      delete newFormatProduct.recovery_email;
      delete newFormatProduct.price;
      delete newFormatProduct.name_extract_description;
      delete newFormatProduct.recurring_value;
      delete newFormatProduct.recurring_comission_type;
      delete newFormatProduct.recurring_comission_value;
      delete newFormatProduct.recurring_frequency;
      delete newFormatProduct.recurring_frequency_type;
      delete newFormatProduct.limit_charges;
      delete newFormatProduct.overdue_limit;
      delete newFormatProduct.permanent_access;
      delete newFormatProduct.membership_price;
      delete newFormatProduct.trial_days;
      delete newFormatProduct.charge_type;
    }

    if (this.charge_type === 'G') {
      delete newFormatProduct.comission_type;
      delete newFormatProduct.comission_value;
      delete newFormatProduct.recruit_commission_type;
      delete newFormatProduct.recruit_commission_value;
      delete newFormatProduct.recurring_comission_type;
      delete newFormatProduct.recurring_comission_value;
    }

    if (this.thankyou_type === 99) newFormatProduct.thankyou_type = 0;
    return newFormatProduct;
  }
}

export default Product;
